export default __webpack_public_path__ + "static/media/search.b519c84c.svg";